<div class="layout-container">
  <app-menu (menuToggled)="onMenuToggled($event)" />
  <div class="content-area" [class.menu-collapsed]="menuCollapsed()">
    <div class="header-section"></div>
    <div class="grid-section">
      <ng-scrollbar >
        <table>
          <thead>
            <tr>
              <th >Client Name</th>
              <th>Booking Ref</th>
              <th>Acc Manager</th>
              <th>Book Date</th>
              <th>Net Price</th>
              <th>Selling Price</th>
              <th>Profit</th>
              <th>Destination</th>
              <th>Hotel</th>
              <th>Check In</th>
              <th>Nights</th>
              <th>Status</th>
              <th>Paid</th>
              <th>Room</th>
              <th>Mode</th>
              <th>Supplier</th>
              <th>Deadline</th>
              <th>Supplier Due</th>
            </tr>
          </thead>
          <tbody>
            <tr class="my-5" *ngFor="let booking of bookings">
              <td>{{ booking.clientName }}</td>
              <td>{{ booking.bookingRef }}</td>
              <td>{{ booking.accManager }}</td>
              <td>{{ booking.bookDate | date: 'dd/MM/yyyy' }}</td>
              <td>{{ booking.netPrice | currency: 'USD': 'symbol' }}</td>
              <td>{{ booking.sellingPrice | currency: 'USD': 'symbol' }}</td>
              <td>{{ booking.profit | currency: 'USD': 'symbol' }}</td>
              <td>{{ booking.destination }}</td>
              <td>{{ booking.hotel }}</td>
              <td>{{ booking.checkIn | date: 'dd/MM/yyyy' }}</td>
              <td>{{ booking.nights }}</td>
              <td>{{ booking.status }}</td>
              <td>{{ booking.paid ? 'Yes' : 'No' }}</td>
              <td>{{ booking.room }}</td>
              <td>{{ booking.mode }}</td>
              <td>{{ booking.supplier }}</td>
              <td>{{ booking.deadline | date: 'dd/MM/yyyy' }}</td>
              <td>{{ booking.supplierDue | date: 'dd/MM/yyyy' }}</td>
            </tr>
          </tbody>
        </table>
      </ng-scrollbar>

    </div>
  </div>
</div>
